import Weather from './components/weather'
document.title="Utkristi | Weather-App"

function App() {
  return (
    <>
    <Weather/>
    </>
  );
}

export default App;
